module.exports = ['$scope', 'MyPlaylistShare', '$state', function MyPlaylistShareModalCtrl($scope, MyPlaylistShare, $state) {

    "use strict";

    $scope.submit = function (email, isAdmin) {
        $scope.isLoading = true;

        new MyPlaylistShare({
            playlist: $scope.playlist,
            user: {email: email},
            isAdmin: isAdmin
        }).$save(function () {
            $scope.$close(true);
        }, function (resp) {
            $scope.isLoading = false;
            $scope.errors = resp.errors;
        });
    };

    $scope.url = $state.href('playlistLanding', {
        id: $scope.playlist.id,
        slug: $scope.playlist.name.toLowerCase().replace(/ /g, '-')
    }, {
        absolute: true
    });

}];


// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistclientbundle/Resources/js/angular/controllers/MyPlaylistShareModalCtrl.js